<template>
  <b-container class="px-0" fluid>
    <div class="background__image content__search-bar">
      <b-container class="w-100 p-0">
        <h4 class="text__title p-0 text-center">
          <span>Search for a hundred skills&nbsp;</span>
          <span>to upgrade your potential</span>
        </h4>
        <SearchBar
          ref="searchBar"
          v-model="searchKeywords"
          placeholder="Search micro-credentials"
          class="component__search-bar input__search-bar p-0"
          search-bar-size="lg"
          @search="handleSearch()"
          @reset="handleReset()"
        >
          <b-button
            slot="button-search-inner"
            class="button-search button__search"
            variant="primary"
            @click="handleSearch()"
          >
            <span v-if="isLoading" class="d-flex align-items-center">
              <b-spinner small></b-spinner>
            </span>
            <span v-else>Search</span>
          </b-button>
        </SearchBar>
        <div v-if="popularSearches" class="wrapper__popular-searches">
          <div class="label__title-popular-searches">Popular searches:</div>
          <div class="list__popular-searches">
            <b-button
              v-for="(keyword, index) in popularSearches"
              :key="index"
              class="button-search tag__popular-search"
              variant="primary"
              @click="handleSearch(keyword)"
            >
              {{ keyword }}
            </b-button>
          </div>
        </div>
      </b-container>
    </div>
  </b-container>
</template>

<script>
import SearchBar from '@/views/LearningUnit/components/SearchBar';
import Setting from '@/models/Setting';

export default {
  name: 'ExploreSearchBar',
  components: {
    SearchBar
  },
  data() {
    return {
      isLoading: false,
      popularSearches: [],
      searchKeywords: []
    };
  },
  created() {
    this.fetchPopularSearches();
  },
  methods: {
    // Fetch popular searches from the API
    async fetchPopularSearches() {
      try {
        const {
          response: { data }
        } = await Setting.api().fetchPopularSearches();

        this.popularSearches = data;
      } catch (error) {
        console.error('Error fetching popular searches:', error);
      }
    },

    handleReset() {
      this.searchKeywords = [];
    },

    async handleSearch(keyword = '') {
      // Check if the search bar is empty
      const hasLocalKeywords = this.searchKeywords.length > 0;

      //provide the search text
      let searchText = hasLocalKeywords ? this.searchKeywords : keyword.toLocaleLowerCase();

      // If the search bar is empty, no keyword is provided
      // when clicked on the search button but @search is not emitted to the parent
      // trigger on the search bar method for submit
      if (!hasLocalKeywords && !searchText && this.$refs.searchBar) {
        this.$refs.searchBar.submitSearchText();
        return;
      }

      this.isLoading = true;

      try {
        let searchQuery = searchText;

        //join into a string
        if (Array.isArray(searchText)) {
          searchQuery = searchText.join(' ');
        }


        // Navigate to the search results page
        this.$router.push({
          name: 'search-results',
          query: {
            q: searchQuery
          }
        });
      } catch (error) {
        console.error('Search error:', error);
      } finally {
        this.searchKeywords = [];
        this.isLoading = false;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.background__image {
  width: 100%;
  height: 100%;
  background-image: url('../../../assets/search-bar-background.svg');
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
}

.content__search-bar {
  padding: 40px 16px;

  .text__title {
    color: var(--white);
    font-weight: 700;
    display: flex;
    flex-direction: column;
    align-items: center;
    flex-wrap: wrap;
    justify-content: center;
  }

  .text__popular-searches {
    color: var(--secondary);
    font-weight: 700;
  }
}

.component__search-bar {
  margin: 16px 0;
  padding: 8px;

  .btn {
    padding: 0px 20px;
    border-radius: 4px;
  }

  .button-search {
    width: max-content;
    margin: 6px 12px 6px 0;
  }
}

.wrapper__popular-searches {
  display: grid;
  grid-template-columns: max-content auto;
  gap: 16px;
  color: var(--secondary);
  font-weight: 700;
  width: 100%;
  white-space: nowrap;
  justify-content: center;
  align-items: center;
  font-size: 14px;

  .list__popular-searches {
    overflow-x: auto;
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 16px;
  }

  .list__popular-searches::-webkit-scrollbar {
    display: none;
  }

  .list__popular-searches {
    -ms-overflow-style: none; /* IE and Edge */
    scrollbar-width: none; /* Firefox */
  }

  .btn-primary {
    background-color: #d4d4d41a;
    color: var(--white);
    border-color: transparent;
    padding: 4px 16px;
    font-weight: 700;
    margin: 4px 0;
    box-shadow: none;
  }
}

@media screen and (min-width: 768px) {
  .content__search-bar {
    padding: 20px 32px;

    .text__title {
      font-size: 36px;
      display: flex;
      flex-direction: row;
    }
  }
  .wrapper__popular-searches {
    font-size: 16px;
  }
}

@media screen and (min-width: 992px) {
  .content__search-bar {
    padding: 48px 32px;
  }
}

@media screen and (min-width: 1200px) {
  .content__search-bar {
    padding: 48px 0;
  }
}
</style>
